import Stack from "@mui/material/Stack";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { theme } from "@polifonia/theme";
import { type FC, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Typography } from "@/components/Typography";

const TableTitle: FC<Typography.Props> = ({ children, ...props }) => {
  return (
    <Typography
      variant="body"
      fontWeight={500}
      color={theme.colors.staticFgTitle}
      {...props}
    >
      {children}
    </Typography>
  );
};

export const Compliance: FC = function Compliance() {
  const { t } = useTranslation();

  const complianceKeywords = useMemo(
    () => [
      {
        language: t("page.channel.whatsapp.compliance.keywords.en.language"),
        optInKeyword: t(
          "page.channel.whatsapp.compliance.keywords.en.optInKeyword",
        ),
        optInReplyMessage: t(
          "page.channel.whatsapp.compliance.keywords.en.optInReplyMessage",
        ),
        optOutKeyword: t(
          "page.channel.whatsapp.compliance.keywords.en.optOutKeyword",
        ),
        optOutReplyMessage: t(
          "page.channel.whatsapp.compliance.keywords.en.optOutReplyMessage",
        ),
      },
      {
        language: t("page.channel.whatsapp.compliance.keywords.zh.language"),
        optInKeyword: t(
          "page.channel.whatsapp.compliance.keywords.zh.optInKeyword",
        ),
        optInReplyMessage: t(
          "page.channel.whatsapp.compliance.keywords.zh.optInReplyMessage",
        ),
        optOutKeyword: t(
          "page.channel.whatsapp.compliance.keywords.zh.optOutKeyword",
        ),
        optOutReplyMessage: t(
          "page.channel.whatsapp.compliance.keywords.zh.optOutReplyMessage",
        ),
      },
      {
        language: t("page.channel.whatsapp.compliance.keywords.ja.language"),
        optInKeyword: t(
          "page.channel.whatsapp.compliance.keywords.ja.optInKeyword",
        ),
        optInReplyMessage: t(
          "page.channel.whatsapp.compliance.keywords.ja.optInReplyMessage",
        ),
        optOutKeyword: t(
          "page.channel.whatsapp.compliance.keywords.ja.optOutKeyword",
        ),
        optOutReplyMessage: t(
          "page.channel.whatsapp.compliance.keywords.ja.optOutReplyMessage",
        ),
      },
      {
        language: t("page.channel.whatsapp.compliance.keywords.th.language"),
        optInKeyword: t(
          "page.channel.whatsapp.compliance.keywords.th.optInKeyword",
        ),
        optInReplyMessage: t(
          "page.channel.whatsapp.compliance.keywords.th.optInReplyMessage",
        ),
        optOutKeyword: t(
          "page.channel.whatsapp.compliance.keywords.th.optOutKeyword",
        ),
        optOutReplyMessage: t(
          "page.channel.whatsapp.compliance.keywords.th.optOutReplyMessage",
        ),
      },
    ],
    [t],
  );

  return (
    <Stack direction="column" gap={2}>
      <Typography
        variant="h3"
        fontWeight="medium"
        color={theme.colors.staticFgTitle}
      >
        {t("page.channel.whatsapp.compliance.keywordHandling.title")}
      </Typography>
      <TableContainer>
        <Table aria-label="keyword handling table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: 100 }}>
                <TableTitle>
                  {t("page.channel.whatsapp.compliance.table.language")}
                </TableTitle>
              </TableCell>
              <TableCell sx={{ minWidth: 220 }}>
                <TableTitle>
                  {t("page.channel.whatsapp.compliance.table.optInKeyword")}
                </TableTitle>
              </TableCell>
              <TableCell sx={{ minWidth: 220 }}>
                <TableTitle>
                  {t(
                    "page.channel.whatsapp.compliance.table.optInReplyMessage",
                  )}
                </TableTitle>
              </TableCell>
              <TableCell sx={{ minWidth: 220 }}>
                <TableTitle>
                  {t("page.channel.whatsapp.compliance.table.optOutKeyword")}
                </TableTitle>
              </TableCell>
              <TableCell sx={{ minWidth: 220 }}>
                <TableTitle>
                  {t(
                    "page.channel.whatsapp.compliance.table.optOutReplyMessage",
                  )}
                </TableTitle>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {complianceKeywords.map((row) => (
              <TableRow key={row.language}>
                <TableCell>
                  <Typography variant="body" fontWeight={500}>
                    {row.language}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body">{row.optInKeyword}</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body">
                    {row.optInReplyMessage}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body">{row.optOutKeyword}</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body">
                    {row.optOutReplyMessage}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  );
};
